<!-- =========================================================================================
	File Name: ItemGridView.vue
	Description: Item Component - Grid VIew
	----------------------------------------------------------------------------------------
	Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
	Author: Pixinvent
	Author URL: http://www.themeforest.net/user/pixinvent
========================================================================================== -->

<template>
  <!-- <div class="item-grid-view vx-row match-height">
        <div class="vx-col" :class="gridColumnWidth" v-for="item in items" :key="item.objectID"> -->
  <vx-card class="grid-view-item overflow-hidden" v-on="$listeners">
    <template slot="no-body">
      <!-- ITEM IMAGE -->
      <div class="item-img-container bg-white  flex items-center justify-center mb-0 cursor-pointer" @click="editImage">
        <img v-if="item.image" :src="item.image?item.image:require('@/assets/images/placeholder/5x4.png')"
          :alt="item.name" class="grid-view-img">
        <p v-else class="text-muted mt-5">
          未添加封面
        </p>
      </div>
      <!-- SLOT: ACTION BUTTONS -->
      <slot name="action-buttons" />
    </template>
  </vx-card>
  <!--  </div>
    </div> -->
</template>

<script>
  export default {
    props: {
      item: {
        type: Object,
        required: true
      },
    },
    mounted() {

    },
    methods: {
      editImage() {

      }
    }
  }
</script>

<style lang="scss" scoped>
  .grid-view-item {
    .grid-view-img {
      max-width: 80%;
      max-height: 80%;
      width: auto;
      transition: .35s;
    }

    &:hover {
      transform: translateY(-5px);
      box-shadow: 0px 4px 25px 0px rgba(0, 0, 0, .25);

      .grid-view-img {
        opacity: 0.9;
      }
    }

    .text-muted {
      color: #999
    }
  }
</style>
